import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({
  faqInContent: {
    transform: 'translateY(-10000px)',
  },
  faqContent: {
    overflowY: 'scroll',
    height: '100%',

    '&::-webkit-scrollbar': {
      display: 'inline-block',
      appearance: 'none',
      marginLeft: '3px',
      width: '13px'
    },

    '&::-webkit-scrollbar-thumb': {
      border: '4px solid rgba(0,0,0,0)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      backgroundColor: 'rgba(0, 0, 0, .5)',
      boxShadow: '0 0 1px rgba(255, 255, 255, .5)'
    }
  },
  question: {
    fontFamily: '"CircularXXWeb-Bold", sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '23px',
    color: theme.palette.codGray,
    paddingBottom: '24px'
  },
  answer: {
    fontFamily: '"CircularXXWeb-Regular", sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.codGray,
    opacity: 0.5,
    paddingBottom: '32px',

  }
}))

export default useStyles
